import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PatchInfo } from 'web/data/models'
import { getCurrentBuild } from 'web/data/core-data'

/**
 * Holds meta-data about the application that we might want to serialize.
 */
export type MetaState = {
    lastKnownPatchInfo: PatchInfo

    lastSelectedFightId: string | undefined
    lastSelectedSetupId: string | undefined

    setupRecovery?: {
        fightId: string
        setupId: string
        editFightJson: string
        editSetupJson: string
    }
}

const initialState: MetaState = {
    lastKnownPatchInfo: getCurrentBuild().patchInfo,

    lastSelectedFightId: undefined,
    lastSelectedSetupId: undefined,

    setupRecovery: undefined
}

const slice = createSlice({
    name: "meta",
    initialState,
    reducers: {
        setLastKnownPatchInfo: (state) => {
            state.lastKnownPatchInfo = getCurrentBuild().patchInfo
        },

        setLastSelectedFightAndSetup: (state, action: PayloadAction<{
            fightId: string
            setupId?: string
        }>) => {
            state.lastSelectedFightId = action.payload.fightId
            state.lastSelectedSetupId = action.payload.setupId
        },

        clearLastSelectedFightAndSetup: (state) => {
            state.lastSelectedFightId = undefined
            state.lastSelectedSetupId = undefined
        },

        clearLastSelectedSetup: (state) => {
            state.lastSelectedSetupId = undefined
        },

        /**
         * WARNING: Destructive operation. When recovery data exists,
         * this will be the field that stores it until the user takes
         * action on it in the UI. Even if the user reloads the
         * application after initial loading.
         *
         * The original data source will be purged instantly when the
         * application loads and this will remain the only source.
         * When you make this call, the recovery data is lost forever.
         */
        clearSetupRecovery: (state) => {
            state.setupRecovery = undefined
        }
    }
})

export const MetaReducer = slice.reducer
export const MetaActions = slice.actions
